import styled, { css, DefaultTheme } from 'styled-components';

import { Text1, Link } from 'app/shared/ui';

import { media } from '../../../../../styles_js/variables';

export const FaqContentSt = styled.div`
  ${media.md(css`
    margin: auto;
  `)}

  ${media.lg(
    css`
      max-width: 788px;
    `,
  )}

  ${media.xl(
    css`
      max-width: 770px;
    `,
  )}
`;

export const PassiveLinkSt = styled(Link)`
  color: ${({ theme: { colors } }) => colors.grayDark};
  text-decoration: none;
`;

export const PassiveTextSt = styled(Text1)`
  margin-top: 40px;
  text-align: center;
  color: ${({ theme: { colors } }: { theme: DefaultTheme }) => colors.grayDark};
`;
